import React, { useState } from 'react';
import SupervisorLayout from '../../components/SupervisorLayout';
import SupervisorGroupCodeField from '../../components/SupervisorGroupCodeField';
import SupervisorBankCodeField from '../../components/SupervisorBankCodeField';
import LotteryCodeField from '../../components/LotteryCodeField';
import DateField from '../../components/DateField';
import { fetchSupervisorPrizedNumbers } from '../../api/supervisor';
import { todayISO } from '../../utils/date';
import './SupervisorPrizedNumbersPage.css';

const money = (n) => Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Filtre Groupe/Banque optionnel et mutuellement exclusif ajoute le
// 2026-09-17 (demande explicite) — meme pattern (resolution au blur en plus
// du modal) que le reste du portail superviseur (vide = toutes ses banks).
const SupervisorPrizedNumbersPage = () => {
  const [date, setDate] = useState(todayISO());
  const [lottery, setLottery] = useState('');
  const [lotteryName, setLotteryName] = useState('');
  const [groupId, setGroupId] = useState('');
  const [groupName, setGroupName] = useState('');
  const [bankId, setBankId] = useState('');
  const [bankName, setBankName] = useState('');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!lottery) { setError('Choisis une loterie.'); return; }
    setLoading(true);
    setError('');
    try {
      setResult(await fetchSupervisorPrizedNumbers({ tirage: lottery, date, group: groupId, bank: bankId }));
    } catch (err) {
      setError('Recherche impossible.');
      setResult(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SupervisorLayout>
      <h2 className="svpg-title">Paris gagnants</h2>

      <div className="svpg-card">
        <form onSubmit={handleSearch} className="svpg-form">
          <div className="svpg-row">
            <label className="svpg-label">Date</label>
            <DateField className="svpg-input" value={date} onChange={setDate} />
          </div>
          <div className="svpg-row">
            <label className="svpg-label">Loterie</label>
            <LotteryCodeField
              value={lottery}
              name={lotteryName}
              onChange={(code) => { setLottery(code); setLotteryName(''); }}
              onResolve={(code, nm) => { setLottery(code); setLotteryName(nm); }}
              inputClass="svpg-input svpg-input-sm"
              iconClass="svpg-icon-btn"
              nameClass="svpg-scope-name"
            />
          </div>

          <div className="svpg-row">
            <label className="svpg-label">Groupe</label>
            <SupervisorGroupCodeField
              value={groupId}
              name={groupName}
              onChange={(id) => { setGroupId(id); setGroupName(''); }}
              onResolve={(id, nm) => {
                setGroupId(id); setGroupName(nm);
                setBankId(''); setBankName('');
              }}
              inputClass="svpg-input svpg-input-sm"
              iconClass="svpg-icon-btn"
              nameClass="svpg-scope-name"
            />

            <label className="svpg-label svpg-label-gap">Banque</label>
            <SupervisorBankCodeField
              value={bankId}
              name={bankName}
              onChange={(id) => { setBankId(id); setBankName(''); }}
              onResolve={(id, nm) => {
                setBankId(id); setBankName(nm);
                setGroupId(''); setGroupName('');
              }}
              inputClass="svpg-input svpg-input-sm"
              iconClass="svpg-icon-btn"
              nameClass="svpg-scope-name"
            />
          </div>

          {error && <p className="svpg-error">{error}</p>}
          <button type="submit" className="svpg-search-btn" disabled={loading}>
            {loading ? 'Recherche...' : 'Chercher'}
          </button>
        </form>
      </div>

      {result && (
        <div className="svpg-card svpg-results">
          <p className="svpg-scope-name">{result.tirage_code} - {result.tirage_name}</p>

          {!result.has_result && <p className="svpg-empty">Aucun numéro gagnant saisi pour ce tirage à cette date.</p>}
          {result.has_result && result.sections.length === 0 && (
            <p className="svpg-empty">Aucun pari sur les numéros gagnants de ce tirage (sur vos banks).</p>
          )}

          {result.sections.map((section) => (
            <div key={section.product_abbr} className="svpg-section">
              <p className="svpg-section-title">{section.product_name}</p>
              <table className="svpg-table">
                <thead>
                  <tr><th>No.</th><th>Points</th><th>Vendu</th><th>Gagné</th><th>Match</th></tr>
                </thead>
                <tbody>
                  {section.rows.map((row) => (
                    <tr key={`${row.numero}-${row.match}`}>
                      <td className="svpg-num">{row.numero}</td>
                      <td>{row.points}</td>
                      <td className="svpg-money">{money(row.vendu)}</td>
                      <td className="svpg-money">{money(row.gagne)}</td>
                      <td>{row.match}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}

          {result.has_result && result.sections.length > 0 && (
            <div className="svpg-totals">
              <div><span>Ventes Brutes</span><span>{money(result.ventes_brutes)}</span></div>
              <div><span>Total des gains</span><span>{money(result.total_gains)}</span></div>
            </div>
          )}
        </div>
      )}
    </SupervisorLayout>
  );
};

export default SupervisorPrizedNumbersPage;
